import { Injectable, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject, fromEvent, debounceTime, takeUntil } from "rxjs";
import { getTokenData } from "./utils/utils";

export interface Menu {
  headTitle1?: string;
  level?: number;
  headTitle2?: string;
  path?: string;
  title?: string;
  type?: string;
  icon?: string;
  active?: boolean;
  bookmark?: boolean;
  pinnedData?: boolean;
  items?: Menu[];
  children?: Menu[];
  roles?: string[];
}

@Injectable({
  providedIn: "root"
})
export class NavService implements OnDestroy {
  public screenWidth = new BehaviorSubject<number>(window.innerWidth);
  private unsubscriber = new Subject<void>();

  public collapseSidebar = window.innerWidth < 1200;
  public MENUITEMS: Menu[] = [];
  public items: BehaviorSubject<Menu[]>;

  constructor(private router: Router) {
    const tokenData = getTokenData(); // Get role from token
    const fullMenu: Menu[] = [
      {
        level: 1,
        title: "Dashboard",
        icon: "stroke-home",
        path: '/portal/dashboard',
        type: "link",
        active: true,
      },
      {
        level: 1,
        title: "My Courses",
        icon: "stroke-blog",
        path: '/portal/category-courses',
        type: "link",
        active: false,
      },
      {
        level: 1,
        title: "Users",
        icon: "stroke-users",
        path: '/portal/users',
        type: "link",
        active: false,
      },
      {
        level: 1,
        title: "Profile",
        icon: "stroke-user",
        path: '/portal/profile',
        type: "link",
        active: false,
      },
    ];

    if (tokenData?.companyData?.isFreeTrial === true) {
      this.MENUITEMS = fullMenu.filter(item => item.title !== 'Dashboard');
    } else {
      this.MENUITEMS = tokenData?.role === 'User'
        ? fullMenu.filter(item => item.title !== 'Dashboard' && item.title !== 'Users')
        : fullMenu;
    }


    this.items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
    this.setScreenWidth(window.innerWidth);

    fromEvent(window, 'resize')
      .pipe(debounceTime(200), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        this.collapseSidebar = evt.target.innerWidth < 1200;
      });
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
